import axios from 'axios';
import { useEffect, useState } from 'react';
import useBackendPath from './useBackendPath';

interface Envs {
  REACT_APP_RECAPTCHA_SITE_KEY: string;
}

const useReactEnvs = () => {
  const [envs, setEnvs] = useState<Envs | null>(null);
  const { backendPath } = useBackendPath();

  useEffect(() => {
    axios
      .get(backendPath + '/api/config', {
        headers: {
          accept: 'application/json',
        },
      })
      .then((res) => res.data)
      .then((data) => {
        setEnvs(data);
      });
  }, [backendPath]);

  return { envs };
};

export default useReactEnvs;
